// extracted by mini-css-extract-plugin
export default {"container":"MunicipalitySettings_container__w5HDC","left":"MunicipalitySettings_left__x6Tez","map":"MunicipalitySettings_map__+vxpe"};